import { useSearch } from "@usereactify/search";
import React, { useCallback, useEffect } from "react";

import { Results } from "@app/scripts/reactify/results/Results";

export const Search: React.FC = (ReactifySearchData) => {
    const { submitSearchTerm, searchTerm } = useSearch();

    const search = useCallback(
        (e) => {
            const searchInput = document.getElementById("Search-In-Template");
            e.preventDefault();
            submitSearchTerm(searchInput?.value);
        },
        [submitSearchTerm]
    );

    useEffect(() => {
        const searchForm = document.querySelector("[data-mainsearch]");
        searchForm?.addEventListener("submit", search);
        return () => {
            searchForm?.removeEventListener("submit", search);
        };
    }, []);

    return <Results ReactifySearchData={ReactifySearchData} searchTerm={searchTerm} />;
};
